import type { TranslationKeys } from '@/shared/i18n/locales/en'
import iconHome          from '@/assets/icons/icon_home.svg'
import iconQuestionnaire from '@/assets/icons/icon_questionnaire.svg'
import iconResults       from '@/assets/icons/icon_results.svg'
import iconContent       from '@/assets/icons/icon_content.svg'
import iconMail          from '@/assets/icons/icon_mail.svg'
import iconUser           from '@/assets/icons/icon_user.svg'
import iconUserManagement from '@/assets/icons/icon_userManagement.svg'

export interface NavItem {
    labelKey: keyof TranslationKeys
    headerTitle?: string
    path: string
    icon: string
    disabled?: boolean
    requiredRoles?: string[]
}

export const NAV_ITEMS: NavItem[] = [
    { labelKey: 'navHome', headerTitle: 'HG-AT/DONATE-AT', path: '/', icon: iconHome },
    { labelKey: 'navQuestionnaires', headerTitle: 'Fragebögen', path: '/fragenboegen', icon: iconQuestionnaire },
    { labelKey: 'navResults',        headerTitle: 'Meine Resultate',  path: '/resultate',      icon: iconResults, disabled: true },
    { labelKey: 'navStudieninfos',   headerTitle: 'Informationen',    path: '/studieninfos',   icon: iconContent },
    { labelKey: 'navKontakt',        headerTitle: 'Kontakt',          path: '/kontakt',        icon: iconMail },
    { labelKey: 'navBenutzerprofil', headerTitle: 'Benutzerprofil',    path: '/benutzerprofil', icon: iconUser },
    { labelKey: 'navAdmin',          headerTitle: 'Benutzerverwaltung', path: '/admin/users',    icon: iconUserManagement, requiredRoles: ['administrator', 'study_team'] },
    { labelKey: 'navAudit',          headerTitle: 'Audit Log',          path: '/admin/audit',    icon: iconContent,        requiredRoles: ['administrator'] },
]

export const getVisibleNavItems = (roles: string[] | undefined): NavItem[] =>
    NAV_ITEMS.filter(
        (item) => !item.requiredRoles || item.requiredRoles.some((r) => roles?.includes(r))
    )
